import styled from "styled-components"

export const BuildingAddressContainer = styled.div`
  .autosuggest__large-list {
    margin-bottom: 1rem;

    li {
      width: calc(100% - 2rem) !important;
      left: 1rem !important;
      margin-top: 1rem;
    }
  }
`
